module.exports = __webpack_public_path__ + "img/天地一体立体观测体系.6de4060d.png";